import styled, { css } from 'styled-components';

interface PortalContainer {
  show: boolean;
  backgroundColor: string;
}

export const PortalContainer = styled.div<PortalContainer>`
  position: absolute;
  top: 100%;
  left: 0;
  height: 0%;
  width: 100%;

  background-color: ${({ backgroundColor }) => backgroundColor};
  overflow: hidden;

  z-index: 65536;

  transition: top 0.2s ease-in-out;

  ${({ show }) =>
  show
    ? css`
          top: 0;
          height: 100%;
        `
    : ''}
`;